export default function( fn, wait, ctx ) {
  let timer = null;
  return function() {
    let len = arguments.length;
    let args = new Array( len );
    let i;

    if ( timer ) {
      window.clearTimeout( timer );
    }

    for ( i = 0; i < len; i++ ) {
      args[ i ] = arguments[ i ];
    }

    timer = window.setTimeout( function() {
      fn.apply( ctx || null, args );
    }, wait );
  };
}
